// text transform

export const capitaliseFirstWord = (string) =>
  string ? string[0].toUpperCase() + string.substring(1).toLowerCase() : '';

export const capitaliseAllWords = (string) => {
  if (!string) return;
  const newString = string
    .split(' ')
    .map((word) => capitaliseFirstWord(word))
    .join(' ');
  return newString;
};

// Replaces underscores with spaces.
// Leading and trailing underscores are removed entirely.
// Sets of multiple adjacent underscores are replaced with a single space
export const replaceUnderscoresWithSpaces = (string) => {
  if (!string) return;
  const newString = string.replace(/^_+|_+$/g, '').replace(/_+/g, ' ');
  return newString;
};

// convert links
export const convertLinks = (string) => {
  const rx =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gim;

  const stringAsList = string?.split(rx) || null;

  if (stringAsList)
    stringAsList.forEach((item, i) => {
      if (rx.test(item))
        stringAsList[i] = (
          <a
            href={item}
            target="_blank"
            rel="noreferrer"
            aria-description="Opens in a new window"
          >
            {item}
          </a>
        );
    });

  return stringAsList || string;
};

/**
 * isStringEmpty
 * @param str
 * @returns {boolean}
 */
export const isStringEmpty = (str = '') => {
  // return true for invalid strings
  if (typeof str !== 'string') {
    return true;
  }
  return !str.trim().length;
};
